import { Button } from '@/components/ui/button';
import { ListFilter } from 'lucide-react';

interface StickyControlsBarProps {
  visible: boolean;
  hasAssets: boolean;
  showSort: boolean;
  onSortClick: () => void;
  onFilterClick: () => void;
  t: (key: string) => string;
}

const StickyControlsBar = ({
  visible,
  hasAssets,
  showSort,
  onSortClick,
  onFilterClick,
  t,
}: StickyControlsBarProps) => {
  if (!hasAssets || !visible) {
    return null;
  }

  return (
    <div
      className="fixed left-0 right-0 z-30 bg-background/95 backdrop-blur-sm border-b border-border transition-opacity duration-300 ease-out"
      style={{ top: 'calc(80px + env(safe-area-inset-top, 0px))' }}
    >
      <div className="max-w-4xl mx-auto px-4 py-2">
        <div className="flex items-center justify-between gap-4">
          {showSort && (
            <Button
              variant="ghost"
              size="sm"
              onClick={onSortClick}
              className="flex items-center gap-1 text-xs"
            >
              <ListFilter className="w-4 h-4" />
              {t('sort')}
            </Button>
          )}

          <Button
            variant="ghost"
            size="sm"
            onClick={onFilterClick}
            className="flex items-center gap-1 text-xs ml-auto"
          >
            <ListFilter className="w-4 h-4" />
            {t('filter')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default StickyControlsBar;
